export default __webpack_public_path__ + "static/Important-Notice_EGTB_EN-f78d96268e7d83f5b34a12163d21d69c.pdf";